import { useMemo } from 'react';

const baseObjects = {
  name: { field: 'name', headerName: 'Employee Name' },
  employee: { field: 'employee', headerName: 'Employee ID' },
  fromDate: { field: 'fromDate', headerName: 'From Date' },
  toDate: { field: 'toDate', headerName: 'To Date' },
  jobClassCode: { field: 'jobClassCode', headerName: 'Job Class Code' },
  payCode: { field: 'payCode', headerName: 'Pay Code' },
  hours: { field: 'hours', headerName: 'Hours' },
  amount: { field: 'hours', headerName: 'Amount' },
  date: { field: 'date', headerName: 'Date' },
  description: { field: 'description', headerName: 'Description' },
  shift: { field: 'shift', headerName: 'Shift' },
};

const columns = {
  overtime: {
    emp: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.payCode,
      baseObjects.hours,
    ],
    date: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.payCode,
      baseObjects.hours,
    ],
  },
  oog: {
    emp: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.jobClassCode,
      baseObjects.payCode,
      baseObjects.hours,
    ],
    date: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.jobClassCode,
      baseObjects.payCode,
      baseObjects.hours,
    ],
  },
  town: {
    emp: [
      baseObjects.name,
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
    date: [
      baseObjects.name,
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
  },
  private: {
    emp: [
      baseObjects.name,
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
    date: [
      baseObjects.name,
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
  },
  stipends_os: {
    emp: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.jobClassCode,
      baseObjects.payCode,
      baseObjects.amount,
    ],
    date: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.jobClassCode,
      baseObjects.payCode,
      baseObjects.amount,
    ],
  },
  stipends_so: {
    emp: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.payCode,
      baseObjects.amount,
    ],
    date: [
      baseObjects.name,
      baseObjects.employee,
      baseObjects.fromDate,
      baseObjects.toDate,
      baseObjects.payCode,
      baseObjects.amount,
    ],
  },
};

export const useColumns = (type, groupby) => {
  return useMemo(() => {
    return columns[type][groupby.toLowerCase()];
  }, [groupby, type]);
};

export default useColumns;
